import {css} from "@panda/css";

import {BrandLightBulbIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

export const PricesHubDataSourcesNote = () => {
    return (
        <aside className={noteStyle}>
            <span className={iconHolderStyle}>
                <BrandLightBulbIcon size="6.4" />
            </span>

            <div className={copyStyle}>
                <Text as="h2" variant="headline_4" className={titleStyle}>
                    Dlaczego cena ofertowa różni się od transakcyjnej?
                </Text>

                <div className={paragraphsStyle}>
                    <Text as="p" variant="body_copy_0" className={paragraphStyle}>
                        To dwa różne zbiory danych. Nie porównujemy ceny tego samego mieszkania przed sprzedażą i po niej.
                    </Text>

                    <Text as="p" variant="body_copy_0" className={paragraphStyle}>
                        Ceny ofertowe dotyczą mieszkań, które pozostają w sprzedaży. Ceny transakcyjne dotyczą lokali już sprzedanych i ujętych w aktach
                        notarialnych. Zbiór transakcji jest przy tym zwykle kilkunastokrotnie mniejszy niż zbiór aktywnych ofert.
                    </Text>

                    <Text as="p" variant="body_copy_0" className={spacedParagraphStyle}>
                        Dane dotyczą też różnych momentów. Cena ofertowa pokazuje bieżącą sytuację na rynku, a cena transakcyjna może odnosić się do mieszkania,
                        którego warunki zakupu ustalono wcześniej.
                    </Text>

                    <Text as="p" variant="body_copy_0" className={spacedParagraphStyle}>
                        Dlatego różnicy między ceną ofertową a transakcyjną nie należy traktować jako przeciętnego rabatu przy zakupie mieszkania.
                    </Text>
                </div>
            </div>
        </aside>
    );
};

const noteStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "1.4rem",
    width: "100%",
    px: 2,
    py: 2,
    backgroundColor: "var(--colors-background-200)",
    borderRadius: 2,

    md: {
        flexDirection: "row",
        px: "2.2rem",
        py: 2.5
    }
});

const iconHolderStyle = css({
    display: "inline-flex",
    flex: "0 0 auto",
    alignItems: "center",
    justifyContent: "center",
    width: "6.4rem",
    height: "6.4rem"
});

const copyStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: "1.4rem",
    minWidth: 0
});

const titleStyle = css({
    margin: 0,
    color: "var(--colors-secondary)",
    fontWeight: 500
});

const paragraphsStyle = css({
    display: "flex",
    flexDirection: "column"
});

const paragraphStyle = css({
    margin: 0,
    color: "var(--colors-secondary)"
});

const spacedParagraphStyle = css({
    margin: 0,
    marginTop: "2.8rem",
    color: "var(--colors-secondary)"
});
import {css} from "@panda/css";

import {BrandLightBulbIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

export const PricesHubDataSourcesNote = () => {
    return (
        <aside className={noteStyle}>
            <span className={iconHolderStyle}>
                <BrandLightBulbIcon size="6.4" />
            </span>

            <div className={copyStyle}>
                <Text as="h2" variant="headline_4" className={titleStyle}>
                    Dlaczego cena ofertowa różni się od transakcyjnej?
                </Text>

                <div className={paragraphsStyle}>
                    <Text as="p" variant="body_copy_0" className={paragraphStyle}>
                        To dwa różne zbiory danych. Nie porównujemy ceny tego samego mieszkania przed sprzedażą i po niej.
                    </Text>

                    <Text as="p" variant="body_copy_0" className={paragraphStyle}>
                        Ceny ofertowe dotyczą mieszkań, które pozostają w sprzedaży. Ceny transakcyjne dotyczą lokali już sprzedanych i ujętych w aktach
                        notarialnych. Zbiór transakcji jest przy tym zwykle kilkunastokrotnie mniejszy niż zbiór aktywnych ofert.
                    </Text>

                    <Text as="p" variant="body_copy_0" className={spacedParagraphStyle}>
                        Dane dotyczą też różnych momentów. Cena ofertowa pokazuje bieżącą sytuację na rynku, a cena transakcyjna może odnosić się do mieszkania,
                        którego warunki zakupu ustalono wcześniej.
                    </Text>

                    <Text as="p" variant="body_copy_0" className={spacedParagraphStyle}>
                        Dlatego różnicy między ceną ofertową a transakcyjną nie należy traktować jako przeciętnego rabatu przy zakupie mieszkania.
                    </Text>
                </div>
            </div>
        </aside>
    );
};

const noteStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "1.4rem",
    width: "100%",
    px: 2,
    py: 2,
    backgroundColor: "var(--colors-background-200)",
    borderRadius: 2,

    md: {
        flexDirection: "row",
        px: "2.2rem",
        py: 2.5
    }
});

const iconHolderStyle = css({
    display: "inline-flex",
    flex: "0 0 auto",
    alignItems: "center",
    justifyContent: "center",
    width: "6.4rem",
    height: "6.4rem"
});

const copyStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: "1.4rem",
    minWidth: 0
});

const titleStyle = css({
    margin: 0,
    color: "var(--colors-secondary)",
    fontWeight: 500
});

const paragraphsStyle = css({
    display: "flex",
    flexDirection: "column"
});

const paragraphStyle = css({
    margin: 0,
    color: "var(--colors-secondary)"
});

const spacedParagraphStyle = css({
    margin: 0,
    marginTop: "2.8rem",
    color: "var(--colors-secondary)"
});
